module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page"
  }, [_c('div', {
    staticClass: "page-content"
  }, [_c('page-nav-bar', {
    attrs: {
      "currentServiceName": "MoneyRoad",
      "subNavTitle": _vm.changePassword_title,
      "closePage": _vm.isSmartphone
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "layoutTop"
  }), _vm._v(" "), _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-10 offset-md-1"
  }, [_c('div', {
    staticClass: "panel21 panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "content-block labelAccordionForm"
  }, [_c('f7-icon', {
    attrs: {
      "f7": "gear"
    }
  }), _vm._v("\n                " + _vm._s(_vm.$t('common.chg_pwd')) + "\n            ")], 1)]), _vm._v(" "), _c('form', [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-4 col-sm-2 col-form-label"
  }, [_vm._v(_vm._s(_vm.$t('common.idtfr')))]), _vm._v(" "), _c('div', {
    staticClass: "col-8 col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.login),
      expression: "login"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.login)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.login = $event.target.value
      }
    }
  })])]), _vm._v(" "), (!_vm.connectToGoogle) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-4 col-sm-2 col-form-label"
  }, [_vm._v(_vm._s(_vm.$t('common.orig_pwd')))]), _vm._v(" "), _c('div', {
    staticClass: "col-8 col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.originalPassword),
      expression: "originalPassword"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": _vm.changePassword_OriginalPassword,
      "type": "password"
    },
    domProps: {
      "value": (_vm.originalPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.originalPassword = $event.target.value
      }
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [(_vm.connectToGoogle) ? _c('label', {
    staticClass: "col-4 col-sm-2 col-form-label"
  }, [_vm._v(_vm._s(_vm.$t('common.pwd')))]) : _c('label', {
    staticClass: "col-4 col-sm-2 col-form-label"
  }, [_vm._v(_vm._s(_vm.$t('common.new_pwd')))]), _vm._v(" "), _c('div', {
    staticClass: "col-8 col-sm-10"
  }, [(_vm.connectToGoogle) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPassword),
      expression: "newPassword"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": _vm.changePassword_Password,
      "type": "password"
    },
    domProps: {
      "value": (_vm.newPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPassword = $event.target.value
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPassword),
      expression: "newPassword"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": _vm.changePassword_NewPassword,
      "type": "password"
    },
    domProps: {
      "value": (_vm.newPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPassword = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-4 col-sm-2 col-form-label"
  }, [_vm._v(_vm._s(_vm.$t('common.conf_pwd')))]), _vm._v(" "), _c('div', {
    staticClass: "col-8 col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.confirmNewPassword),
      expression: "confirmNewPassword"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": _vm.changePassword_ConfirmPassword,
      "type": "password"
    },
    domProps: {
      "value": (_vm.confirmNewPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.confirmNewPassword = $event.target.value
      }
    }
  })])]), _vm._v(" "), (_vm.connectToGoogle) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "text-right col-sm-12 small font-italic"
  }, [_vm._v(_vm._s(_vm.$t('profilesPage.ggl_check_pwd')))])]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2 offset-md-9",
    class: _vm.colorBottomButton
  }, [_c('button', {
    staticClass: "button-action firstButtonMarginTop",
    attrs: {
      "round": "",
      "title": _vm.changePassword_Validatechanges
    },
    on: {
      "click": _vm.changePassword
    }
  }, [_c('i', {
    staticClass: "icon fa fa-save"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('common.sve')))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "toolbarPageBottomBlank"
  })], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3bbc9fb6", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3bbc9fb6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/user/CMChangePassword.vue
// module id = 1657
// module chunks = 2